import InlinePage from 'components/Page/Inline';
import ReadableWidthTemplate from 'components/templates/ReadableWidth';

export default function CpicPrioritization({}) {
  return (
    <ReadableWidthTemplate title="CPIC Prioritization">
      <InlinePage id="cpicPrioritization" />
    </ReadableWidthTemplate>
  );
}
